import { render, staticRenderFns } from "./distributionCheck.vue?vue&type=template&id=13f9a0f4&scoped=true"
import script from "./distributionCheck.vue?vue&type=script&lang=js"
export * from "./distributionCheck.vue?vue&type=script&lang=js"
import style0 from "./distributionCheck.vue?vue&type=style&index=0&id=13f9a0f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f9a0f4",
  null
  
)

export default component.exports